/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import AuthService from 'cio/services/auth';
import EnvironmentModel from 'cio/models/environment';
import AccountService from 'cio/services/account';

interface SettingsWorkspacesTableSignature {
  Args: {
    environments: EnvironmentModel[];
    readOnly: boolean;
  };
  Element: HTMLTableElement;
}

export default class SettingsWorkspacesTable extends Component<SettingsWorkspacesTableSignature> {
  @service auth!: AuthService;
  @service account!: AccountService;

  get onlyOneEnvironment() {
    return this.args.environments.length === 1;
  }

  get disableDelete() {
    return this.args.readOnly || this.onlyOneEnvironment;
  }

  get environmentUsages() {
    return this.account.current?.usage?.environmentUsages ?? [];
  }
}
